import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Dialog } from '@datacamp/waffles-modals';
import React from 'react';
import FeedbackForm from '../FeedbackForm';
import Rating from '../Rating';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RATING_STATUS = {
  ERROR: 'ERROR',
  NONE: 'NONE',
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED'
};
const defaultProps = {
  feedbackThreshold: 0,
  size: Rating.defaultProps.size
};
class AsyncRating extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "isMounted", false);
    _defineProperty(this, "submitRating", _ref => {
      let {
        rating,
        userFeedback
      } = _ref;
      const {
        onRate
      } = this.props;
      this.setState({
        status: RATING_STATUS.PENDING
      });
      return Promise.resolve(onRate({
        rating,
        userFeedback
      })).then(() => {
        if (this.isMounted) {
          this.setState({
            status: RATING_STATUS.RESOLVED
          });
        }
      }).catch(() => {
        if (this.isMounted) {
          this.setState({
            status: RATING_STATUS.ERROR
          });
        }
      });
    });
    _defineProperty(this, "selectRating", rating => {
      const {
        feedbackThreshold,
        onContinue
      } = this.props;
      const {
        status
      } = this.state;

      // disable rating if already submit
      if (status !== RATING_STATUS.NONE) {
        return false;
      }
      this.setState({
        rating
      });
      if (rating <= feedbackThreshold) {
        return this.setState({
          modalVisible: true
        });
      }
      return this.submitRating({
        rating
      }).then(() => {
        if (onContinue != null) {
          onContinue();
        }
      });
    });
    _defineProperty(this, "closeModal", () => {
      const {
        rating,
        status
      } = this.state;
      if (status === RATING_STATUS.NONE) {
        this.submitRating({
          rating
        });
      }
      this.setState({
        modalVisible: false
      });
    });
    _defineProperty(this, "submitForm", () => {
      const {
        rating,
        userFeedback
      } = this.state;
      return this.submitRating({
        rating,
        userFeedback
      });
    });
    _defineProperty(this, "getModalContent", () => {
      const {
        status,
        userFeedback
      } = this.state;
      const {
        onContinue
      } = this.props;
      switch (status) {
        case RATING_STATUS.NONE:
        case RATING_STATUS.PENDING:
          return ___EmotionJSX(FeedbackForm.Input, {
            disabled: status === RATING_STATUS.PENDING,
            feedbackMessage: userFeedback,
            onCancel: this.closeModal,
            onFeedbackMessageChange: value => {
              this.setState({
                userFeedback: value
              });
            },
            onSubmit: this.submitForm
          });
        case RATING_STATUS.RESOLVED:
          return ___EmotionJSX(FeedbackForm.Success, {
            onClick: onContinue
          });
        case RATING_STATUS.ERROR:
          return ___EmotionJSX(FeedbackForm.Failure, {
            buttonLabel: "Close",
            onClick: this.closeModal
          });
        default:
          throw Error();
      }
    });
    this.state = {
      modalVisible: false,
      rating: undefined,
      status: RATING_STATUS.NONE
    };
  }
  componentDidMount() {
    this.isMounted = true;
  }
  componentWillUnmount() {
    this.isMounted = false;
  }
  render() {
    const {
      size
    } = this.props;
    const {
      modalVisible,
      rating
    } = this.state;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Rating, {
      onRate: this.selectRating,
      rating: rating,
      size: size
    }), ___EmotionJSX(Dialog, {
      isOpen: modalVisible,
      onClose: this.closeModal,
      width: 350
    }, this.getModalContent()));
  }
}
_defineProperty(AsyncRating, "defaultProps", defaultProps);
export default AsyncRating;